/** The `model` options of the GPT Image 2.5 definition, mirroring core's `GptImage25Variant`. */
export const GPT_IMAGE_25_FLARE_VARIANT = 'Flare';
export const GPT_IMAGE_25_SUNBURST_VARIANT = 'Sunburst';
